module.exports = __webpack_public_path__ + "img/IEC证书.88e8b6b5.svg";